import React from 'react';
import { Chip } from '@mui/material';
import { QueryBuilder } from '@mui/icons-material';
import { getQuantityUrgencyColor, getTimeUrgencyColor } from 'utils/UI';
import { offerExpiration } from 'utils/offerExpiration';
import { unavailableOfferLabel } from '../utils';

const unavailableChipSx = (theme) => ({
  backgroundColor: theme.palette.action.disabledBackground,
  borderColor: theme.palette.action.disabled,
  color: theme.palette.text.disabled,
  '& .MuiChip-icon': {
    color: 'inherit',
  },
});

const OfferStatusChips = ({
  active,
  claimsRemaining,
  endDate,
  isPreview,
  showUnavailableLabels = false,
  unlimitedClaims = false,
}) => {
  const expiration = offerExpiration(endDate);
  const daysRemaining = expiration.daysRemaining ?? Infinity;
  const quantity = claimsRemaining !== undefined && claimsRemaining !== null
    ? claimsRemaining
    : isPreview ? 100 : claimsRemaining;
  const isUnavailable = showUnavailableLabels && !active && !isPreview;
  const quantityLabel = isUnavailable
    ? unavailableOfferLabel
    : unlimitedClaims ? 'No limit' : quantity ? `${quantity} left` : 'Depleted';
  const timeLabel = isUnavailable
    ? unavailableOfferLabel
    : expiration.label;
  const quantityForColor = unlimitedClaims ? 100 : quantity;

  return (
    <>
      <Chip
        label={quantityLabel}
        variant={isUnavailable ? 'outlined' : 'filled'}
        sx={isUnavailable
          ? unavailableChipSx
          : (theme) => {
            const backgroundColor = getQuantityUrgencyColor(quantityForColor, theme);
            return {
              backgroundColor,
              color: theme.palette.getContrastText(backgroundColor),
            };
          }}
      />
      <Chip
        label={timeLabel}
        icon={(
          <QueryBuilder
            htmlColor={!isUnavailable && daysRemaining < 5 ? '#fff' : undefined}
          />
        )}
        variant="outlined"
        sx={isUnavailable
          ? unavailableChipSx
          : (theme) => ({
            backgroundColor: getTimeUrgencyColor(daysRemaining, theme),
            color: theme.palette.grey[800],
          })}
      />
    </>
  );
};

export default OfferStatusChips;
